<template>
    <div :class="['card-house', { 'card-house--over-the-edge': isOverTheEdge }]" :style="objectStyle" ref="houseCard">
        <div class="card-house__wrapper" v-if="card && Object.keys(card).length">
            <div class="card-house__image-wrapper">
                <img v-if="card.imgUrl" class="card-house__image" :src="card.imgUrl" :alt="card.title" />
            </div>

            <LandStatus class="card-house__status" :landPlotStatus="card.status" />

            <div class="card-house__body">
                <h2 class="card-house__body-title">
                    {{ card.withHouse ? 'Проект' : '' }}
                    <span class="card-house__body-title-hl">{{ card.title }} </span>{{
                        card.params.streetName
                            ? `, ${card.params.streetName}`
                            : ''
                    }}{{
                        card.params.streetNumber
                            ? `, ${card.params.streetNumber}`
                            : ''
                    }}
                </h2>

                <ul class="card-house__body-list" v-if="card.params && Object.keys(card.params).length">
                    <li class="card-house__body-list-item" v-if="card.withHouse">
                        <p class="card-house__body-list-item-label">
                            Площадь дома, м2
                        </p>

                        <p class="card-house__body-list-item-value">
                            {{ card.params.areaHouse }}
                        </p>
                    </li>

                    <li class="card-house__body-list-item">
                        <p class="card-house__body-list-item-label">
                            Площадь участка, соток
                        </p>

                        <p class="card-house__body-list-item-value">
                            {{ card.params.areaPlot }}
                        </p>
                    </li>

                    <li class="card-house__body-list-item" v-if="card.params.houseOut">
                        <p class="card-house__body-list-item-label">
                            Срок сдачи
                        </p>

                        <p>{{ card.params.houseOut }}</p>
                    </li>
                </ul>

                <div v-if="isSold || card.price || card.newPrice" class="card-house__body-price">
                    <div v-if="isSold" class="card-house__body-price-set">
                        <div class="card-house__body-price-value card-house__body-price-value--sold">
                            Продано
                        </div>
                    </div>

                    <template v-else>

                        <div v-if="card.price && card.price === 1" class="card-house__body-price-set">
                            <div class="card-house__body-price-value">
                             Скоро в продаже
                            </div>
                        </div>
                        
                        <div v-if="card.price && card.price !== 1" class="card-house__body-price-set">
                            <div class="card-house__body-price-label" v-html="`Цена с ${switchCostLabel(card.price, [
                                `<b
                                >чистовой отделкой</b
                            >`,
                                `отделкой <b>Black box</b>`,
                            ])}`
                                "></div>
                            <div class="card-house__body-price-value">
                             {{ `${formatedCost(card.price)} ₽` }}
                            </div>
                        </div>

                        <div v-if="card.newPrice" class="card-house__body-price-set">
                            <div class="card-house__body-price-label" v-html="`Цена с ${switchCostLabel(
                                card.newPrice || 0,
                                [
                                    `<b
                                >чистовой отделкой</b
                            >`,
                                    `отделкой <b>White box</b>`,
                                ],
                            )}`
                                "></div>
                            <div class="card-house__body-price-value">
                                {{ `${formatedCost(card.newPrice || 0)} ₽` }}
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="card-house__void" v-else>
            <p>Нет данных</p>
        </div>

        <div v-show="card &&
            Object.keys(card).length &&
            (card.discount.value || card.action)
            " class="card-house-discount card-house__discount" :style="{
                'background-image': `url(${getURL()}/${require('@/assets/img/svg/bookmark.svg')})`,
            }">
            <div class="card-house-discount__wrapper">
                <div v-show="isDiscount" class="card-house-discount__small-text">
                    Скидка
                </div>

                <div class="card-house-discount__action-text" v-show="!isDiscount">
                    Акция
                </div>

                <div v-show="card && Object.keys(card).length && card.discount.value
                    " class="card-house-discount__big-text">
                    {{
                        card && Object.keys(card).length && card.discount.value
                            ? card.discount.value
                            : ''
                    }}%
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import LandStatus from '../commons/LandStatus.vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { cashSpacer } from '@/helpers/cashHelpers';
import { getURL } from '@/helpers/routeHelpers';
import { switchCostLabel } from '@/helpers/costHelpers';

const houseCard = ref<HTMLElement | null>(null);
const isOverTheEdge = ref(false);

const isDiscount = computed(() => {
    return card.value &&
        Object.keys(card.value).length &&
        card.value.discount.value
        ? true
        : false;
});

const statusCardHouseShow = computed(() => {
    return cardSettingsStore.STATUS_CARD_HOUSE_SHOW;
});

const objectStyle = computed(() => {
    const ARROW_HEIGHT = 8;
    const {
        x,
        y,
        width: widthPath,
        top: topPath,
        height: heightPath,
    } = position.value;
    let widthCard = 0;
    let heightCard = 0;
    let top = y;
    let left = x + widthPath / 2;

    if (houseCard.value && houseCard.value instanceof Element) {
        widthCard = houseCard.value.clientWidth;
        heightCard = houseCard.value.clientHeight;

        isOverTheEdge.value = topPath - heightCard - ARROW_HEIGHT < 0;

        left = left - widthCard / 2;

        if (isOverTheEdge.value) {
            top = top + heightPath + ARROW_HEIGHT;
        } else {
            top = top - heightCard - ARROW_HEIGHT;
        }
    }

    return {
        left: `${left}px`,
        top: `${top}px`,
        opacity: statusCardHouseShow.value ? '1' : '0',
    };
});

const card = computed(() => {
    return landPlotStore.LAND_PLOT_CARD_MINI;
});

const position = computed(() => {
    return cardSettingsStore.POSITION_CARD_HOUSE;
});

const isSold = computed(() => {
    return (
        (!card.value?.price && !card.value?.newPrice) ||
        card.value.status === 'occupied'
    );
});

function formatedCost(price: number) {
    return cashSpacer(price, ' ');
}
</script>

<style lang="less">
.card-house {
    position: absolute;
    z-index: 100;
    width: 312px;
    background-color: @simple-light;
    border: 1px solid @success;
    padding: 12px 12px 22px;
    transition: all 0.3s ease;
    pointer-events: none;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 14px solid transparent;
        border-right: 14px solid transparent;
        border-top: 8px solid @simple-light;
        filter: drop-shadow(0px 1px 0 @success);
    }

    &--over-the-edge {
        &::after {
            top: auto;
            bottom: 100%;
            border-top: 0;
            border-bottom: 8px solid @simple-light;
            filter: drop-shadow(0px -1px 0 @success);
        }
    }

    // .card-house__image
    &__image-wrapper {
        height: 160px;
        margin-bottom: 16px;
        background-color: rgba(@success, 0.5);
    }

    // .card-house__image
    &__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    // .card-house__current-value
    &__old-value {
        display: block;
        text-align: right;
        font-size: 18px;
        line-height: 21.6px;
        text-decoration-line: line-through;
        color: @medium-dark-gray;
    }

    // .card-house__current-value
    &__current-value {
        font-size: 26px;
        font-weight: 500;
        line-height: 31.2px;
        letter-spacing: -0.03em;
        text-align: right;

        &--free {
            color: @success;
        }

        &--booked {
            color: @warning;
        }

        &--occupied {
            color: @danger;
        }
    }

    &__status {
        position: absolute;
        top: 26px;
        left: 26px;
    }

    // .card-house__body
    &__body {

        // .card-house__body-title
        &-title {
            font-size: 24px;
            line-height: 27.6px;

            // .card-house__body-title-hl
            &-hl {
                color: @light-green;
            }
        }

        // .card-house__body-list
        &-list {
            padding: 0 !important;
            margin-top: 12px !important;
            display: flex;
            flex-direction: column;
            gap: 4px;

            // .card-house__body-list-item
            &-item {
                display: flex;
                justify-content: space-between;
                padding: 10px 16px;
                background-color: @light-gray;
                font-size: 12px;
                line-height: 15px;
                letter-spacing: 0.02em;

                // .card-house__body-list-item-label
                &-label {
                    color: @medium-dark-gray;
                }

                // .card-house__body-list-item-value
                &-value {
                    color: @dark;
                    font-weight: 600;
                }
            }
        }

        &-price {
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 16px;

            &-label {
                .text-3();

                margin-bottom: 4px;
                color: @dark;
            }

            &-value {
                font-size: 20px;
                line-height: 24px;
                color: @success;

                &--sold {
                    color: @medium-dark-gray;
                }
            }
        }
    }

    // .card-house__void
    &__void {}

    &__discount {
        position: absolute;
        top: 0;
        right: 36px;
    }

    &-discount {
        display: flex;
        align-items: center;
        width: 54px;
        height: 69px;
        background-repeat: no-repeat;
        font-family: 'Open Sans', sans-serif;
        color: @simple-light;
        filter: drop-shadow(0px 4px 20px rgba(19, 19, 17, 0.15));

        &__wrapper {
            flex: 1 1 0;
        }

        &__small-text {
            font-size: 11px;
            font-weight: 400;
            line-height: 16.5px;
            text-align: center;
        }

        &__big-text {
            .text-2();

            text-align: center;
        }

        &__action-text {
            font-family: 'Open Sans', sans-serif;
            font-size: 12px;
            font-weight: 700;
            line-height: 16.2px;
            text-align: center;
        }
    }
}
</style>
